/**
 * Whether the Adjust disclosure is open — the four dials of the next run.
 *
 * It began as the phone's: the bottom of the map is one line and the input, and
 * the composer's four dials (lens, temper, moves, the spend cap) and the replay
 * dock beneath it took 46% of a 390×844 screen between them, so both folded
 * behind one Adjust press (D158). The desktop has it too now. Its four chips
 * each opened a popover over the map, and the run strip that replaced them
 * (`ui/RunStrip.tsx`) opens the same four dials as one panel in the composer's
 * own flow — the same Adjust on every width, and still a disclosure of controls
 * that already exist: no setting is added, moved or renamed.
 *
 * Module state rather than the store's, for two readers that are not parent and
 * child: the strip's own button and App, which mounts the phone's replay dock as
 * the composer's sibling and shows it while this is open. The store is
 * framing's and persistence's, and a view toggle that dies with the tab has no
 * business in either. Closed on every load, and whenever a run goes live: the
 * live strip has no dials to show.
 */

import { useSyncExternalStore } from 'react'

let open = false
const watchers = new Set<() => void>()

export function adjustOpen(): boolean {
  return open
}

export function setAdjustOpen(next: boolean): void {
  if (next === open) return
  open = next
  for (const w of watchers) w()
}

function onAdjustChange(fn: () => void): () => void {
  watchers.add(fn)
  return () => watchers.delete(fn)
}

export function useAdjustOpen(): boolean {
  return useSyncExternalStore(onAdjustChange, adjustOpen, adjustOpen)
}
